import { cn } from "@portal/components/lib/utils";

export const QuickSubmitFormItemGroup = ({
	children,
	className,
	...rest
}: {
	children: React.ReactNode;
	className?: string;
}) => {
	return (
		<div className={cn("flex flex-col gap-[13px]", className)} {...rest}>
			{children}
		</div>
	);
};
